module.exports = __webpack_public_path__ + "img/Malawi.56d0f32b.png";